import { useEffect, useState } from "react";
import api from "@/lib/api";
import HymnLibrary from "./HymnLibrary";
import ImportPanel from "./ImportPanel";
import Denominations from "./Denominations";
import Mappings from "./Mappings";
import ProjectionSubs from "./ProjectionSubs";

const TABS = [["library", "Hymn library"], ["import", "Import hymns"], ["denominations", "Denominations"], ["mappings", "Hymn mapping"], ["subs", "Subscriptions & pricing"]];

export default function ProjectionAdmin() {
  const [tab, setTab] = useState("library");
  const [stats, setStats] = useState(null);
  const loadStats = () => api.get("/admin/projection/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { loadStats(); }, [tab]);
  return (
    <div className="mt-8 space-y-6" data-testid="projection-admin">
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="projection-admin-stats">
          {[["English hymns", `${stats.languages.en.published}/${stats.languages.en.total}`], ["Yoruba hymns", `${stats.languages.yo.published}/${stats.languages.yo.total}`],
            ["Linked EN/YO", stats.linked_pairs], ["Denominations", stats.denominations], ["Mappings", stats.mappings]].map(([l, v]) => (
            <div key={l} className="luxury-card rounded-lg p-3"><div className="text-[10px] tracking-widest uppercase text-neutral-500">{l}</div><div className="font-serif-display text-2xl text-white">{v}</div></div>
          ))}
        </div>
      )}
      <div className="flex gap-2 border-b border-white/10 overflow-x-auto">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`proj-admin-tab-${k}`}
            className={`px-4 py-2.5 text-[11px] tracking-widest uppercase -mb-px border-b-2 whitespace-nowrap ${tab === k ? "border-[#D4AF37] text-white" : "border-transparent text-neutral-400 hover:text-white"}`}>{l}</button>
        ))}
      </div>
      {tab === "library" && <HymnLibrary onChanged={loadStats} />}
      {tab === "import" && (
        <ImportPanel endpoint="/admin/projection/import" testId="hymn-import" title="Import CAC hymns" withLanguage
          help={<>Upload <b>.csv</b>, <b>.xlsx</b> or <b>.json</b> — one hymn per row. Columns: <code>number</code> (CAC hymn number), <code>title</code>, <code>lyrics</code> (verses separated by a blank line; start a block with <code>Chorus:</code> or <code>Ègbè:</code> for a chorus) — or <code>verse1</code>, <code>verse2</code>… plus <code>chorus</code>. Optional <code>first_line</code>, and <code>linked_number</code> (the CAC number of the same hymn in the other language, to link English ↔ Yoruba). CAC numbers are kept exactly as in your file.</>} />
      )}
      {tab === "denominations" && <Denominations onChanged={loadStats} />}
      {tab === "mappings" && <Mappings onChanged={loadStats} />}
      {tab === "subs" && <ProjectionSubs />}
    </div>
  );
}
